import Sortable from '@stimulus-components/sortable'

export default class extends Sortable {
  static values = {
    ...Sortable.values,
    positionField: { type: String, default: 'position_score' }
  }

  get options () {
    return {
      ...super.options,
      onEnd: this.onEnd.bind(this)
    }
  }

  onEnd () {
    this.updatePositionFields()
  }

  updatePositionFields () {
    const items = this.element.querySelectorAll(':scope > *:not([style*="display: none"])')

    items.forEach((item, index) => {
      const input = item.querySelector(`input[name*="[${this.positionFieldValue}]"]`)
      if (input) {
        input.value = index + 1
      }
    })
  }
}
